import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import {
  Button,
  Empty,
  Input,
  message,
  Modal,
  Popconfirm,
  Select,
  Spin,
} from 'antd'
import { getWind2History } from 'api/pgads'
import { rowHeaderRender } from 'core'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Content, FullHeightSizer } from 'core/screen-util'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import R from 'ramda'

export const timeZoneOption = ({ daylightSavings = 'N', pzone = '' }) => {
  if (daylightSavings !== 'N') {
    const zone = `${pzone.substring(0, pzone.length - 2)}D${pzone.substring(
      pzone.length - 1,
      pzone.length
    )}`
    return [
      { key: pzone, text: pzone, value: pzone },
      { key: zone, text: zone, value: zone },
    ]
  }
  return [{ key: pzone, text: pzone, value: pzone }]
}

export const getTimeZone = ({ date, pzone = '', daylightSavings = 'N' }) => {
  const timeZoneOptMap = timeZoneOption({ daylightSavings, pzone })

  // date.isDST false when calling secound time so nee to creat new moment
  return date && timeZoneOptMap.length > 0
    ? moment(
        moment(date).format('MM/DD/YYYY HH:mm'),
        'MM/DD/YYYY HH:mm'
      ).isDST() && daylightSavings === 'Y'
      ? (timeZoneOptMap[1] || {}).text || ''
      : timeZoneOptMap[0].text
    : ''
}

export const RenameModal = ({ modalFor, list, hide, onOk }) => {
  const [oldId, setOldId] = useState()
  const [newId, setNewId] = useState('')

  return (
    <Modal
      maskClosable
      title={'Rename ' + modalFor}
      visible
      onCancel={() => hide()}
      footer={[
        <Button key="back" type="primary" onClick={() => hide()}>
          Close
        </Button>,
        <Popconfirm
          key="submit"
          title={
            'This will change the old ' +
            modalFor +
            ' "' +
            (oldId?.includes('||') ? oldId.split('||')[0] : oldId) +
            '" to new "' +
            newId +
            '". Are you sure to continue?'
          }
          okText="Yes"
          cancelText="No"
          onConfirm={() => {
            hide()
            onOk({ oldId, newId })
          }}
          placement="bottomRight"
          disabled={!oldId || !newId}
        >
          <Button
            type="primary"
            onClick={() => {
              if (!oldId || !newId) {
                message.info(
                  !oldId
                    ? 'Please, Select Old ' + modalFor + ' ID to Rename'
                    : 'Please, Enter New ' + modalFor + ' ID to Save'
                )
              }
            }}
          >
            Ok
          </Button>
        </Popconfirm>,
      ]}
      destroyOnClose
      closable
    >
      <div>
        <Select
          style={{ width: '200px', marginRight: '10px' }}
          placeholder={'Old ' + modalFor + ' ID'}
          value={oldId}
          onChange={c => setOldId(c)}
        >
          {list.map(s => (
            <Select.Option key={s.value} value={s.value}>
              {s.label}
            </Select.Option>
          ))}
        </Select>
        =
        <Input
          style={{
            gridColumnEnd: 'span 3',
            marginLeft: '10px',
            width: '200px',
          }}
          placeholder={'New ' + modalFor + ' ID'}
          value={newId}
          onChange={e => setNewId(e.target.value)}
        />
      </div>
    </Modal>
  )
}

export const HistoryModal = ({ dataName, apiTargetInfo, hide, setError }) => {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getWind2History(apiTargetInfo)({ dataName }).fork(setError, data => {
      setHistory(data)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      maskClosable
      title="Rename History"
      width="70vw"
      visible
      footer={null}
      onCancel={() => hide()}
      destroyOnClose
      closable
    >
      <Spin spinning={loading}>
        <FullHeightSizer heightOffset={300}>
          {({ height, width }) =>
            history.length > 0 ? (
              <Grid
                sortEnabled
                data={history}
                headers={historyHeaders}
                altBy={u => u.oldId}
                altBgColor="#ebebeb"
                render={virtualizedGridRenderer({
                  rowHeaderRender,
                  height,
                  width,
                })}
                isEditable={false}
                initialSortOptions={historyHeaders}
              />
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty imageStyle={{ paddingTop: '30px' }} />
              </Content>
            )
          }
        </FullHeightSizer>
      </Spin>
    </Modal>
  )
}

const historyHeaders = [
  strCol({
    ident: 'dataName',
    display: 'Data Name',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'oldId',
    display: 'Old ID',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'newId',
    display: 'New ID',
    isFiltered: true,
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]

export const getValidPlantList = (plantList, subGroup) => {
  // plantId must in subGroup
  const subGroupPlantCore = plantList.map(p => p.plantId)

  const subGroupPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(subGroup)

  const nercReportingPlants = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => subGroupPlantIds.includes(id))
  )(subGroupPlantCore)

  return nercReportingPlants
}

export const getValidActivePlantList = (
  plantList,
  subGroup,
  activePlantIds
) => {
  const subGroupPlantCore = plantList.map(p => p.plantId)
  const subGroupPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(subGroup)

  const validActivePlants = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => subGroupPlantIds.includes(id)),
    R.filter(id => activePlantIds.includes(id))
  )(subGroupPlantCore)

  return validActivePlants
}

export const getValidActivePlantWithStorageGroup = (
  plantList,
  storageGroup = [],
  activePlantIds
) => {
  const storagePlantCore = plantList
    .filter(
      f =>
        f.onSiteStorage === 'Y' ||
        f.onSiteStorage === 'y' ||
        f.onSiteStorage === 'YES'
    )
    .map(p => p.plantId)

  const storagePlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(storageGroup)

  const validActivePlant = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => storagePlantIds.includes(id)),
    R.filter(id => activePlantIds.includes(id))
  )(storagePlantCore)

  return validActivePlant
}
